class Store {
  constructor () {
    this.state = {
      sidebarClosed: window.innerWidth < 768
    };
  }

  toggleSidebar () {
    this.state.sidebarClosed = !this.state.sidebarClosed;
  }

  closeMobileSidebar () {
    if (window.innerWidth < 768) {
      this.state.sidebarClosed = true;
    }
  }
}

export default new Store();
